import { CloseIcon } from '@chakra-ui/icons';
import { Spinner } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { ConfirmationModalType } from '../types/MovimentacaoFundosType';

const today = new Date();
const dataInicio = new Date('2023-11-01T12:00:00.000-03:00');
const dataFim = new Date('2023-11-01T22:00:00.000-03:00');

export const ConfirmationModal = ({
  title,
  content,
  negativeButtonText,
  afirmativeButtonText,
  handleModalConfirmation
}: ConfirmationModalType) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    document.body.classList.add('tw-modal-open');

    return () => {
      document.body.classList.remove('tw-modal-open');
    };
  }, []);
  return (
    <>
      <div className="tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-full tw-bg-gray-500 tw-opacity-50 "></div>
      {isLoading ? (
        <div className="tw-flex tw-justify-center tw-items-center tw-absolute tw-top-1/2 tw-left-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2 tw-w-full tw-h-full">
          <Spinner size="xl" color="#146CFA" />
        </div>
      ) : (
        <div className="tw-fixed tw-top-1/2 tw-left-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2 tw-bg-white tw-rounded-[24px] tw-p-[30px] tw-w-[670px] tw-shadow-lg">
          <div
            className="tw-absolute tw-right-[30px] tw-cursor-pointer"
            onClick={() => handleModalConfirmation('close-modal')}
          >
            <CloseIcon />
          </div>
          <div className="tw-flex tw-flex-col tw-gap-10 tw-text-center tw-pl-[40px] tw-pr-[40px]">
            <h2 className="tw-font-bold tw-text-2xl tw-leading-8">{title}</h2>
            <p className="tw-text-2xl tw-leading-8">{content}</p>
          </div>
          <div className="tw-flex tw-justify-between tw-mt-[30px]  tw-pl-[60px] tw-pr-[60px]">
            {negativeButtonText ? (
              <button
                className="tw-w-[204px] tw-h-[44px] tw-bg-[#FFFFFF] tw-text-[#1C375C] tw-font-bold tw-focus:outline-none tw-focus:shadow-outline tw-border-2 tw-border-[#001E64] tw-rounded-[7px]"
                onClick={() => handleModalConfirmation('close-modal')}
              >
                {negativeButtonText}
              </button>
            ) : (
              ''
            )}
            {afirmativeButtonText ? (
              <button
                className="tw-w-[204px] tw-h-[44px] tw-bg-[#FA6B25] tw-border-[#FA6B25] tw-text-[#FFFFFF] tw-font-bold  tw-focus:outline-none tw-focus:shadow-outline tw-border-2 tw-rounded-[7px]"
                onClick={() => {
                  setIsLoading(true);
                  handleModalConfirmation('submit');
                }}
                disabled={today >= dataInicio && today <= dataFim}
              >
                {afirmativeButtonText}
              </button>
            ) : (
              ''
            )}
          </div>
        </div>
      )}
    </>
  );
};
